import type { ReactNode } from "react";
import { ArrowRight } from "lucide-react-native";
import type { StyleProp, TextStyle, ViewStyle } from "react-native";
import type { HapticStyle } from "../haptics";
import { VelvetPrimaryButton } from "./VelvetPrimaryButton";

export type WarmButtonProps = {
  title: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
  flex?: number;
  fullWidth?: boolean;
  leading?: ReactNode;
  icon?: ReactNode;
  trailing?: ReactNode;
  showArrow?: boolean;
  hapticStyle?: HapticStyle | null;
  style?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
};

export default function WarmButton({
  title,
  onPress,
  disabled,
  loading = false,
  flex,
  fullWidth,
  leading,
  icon,
  trailing,
  showArrow = true,
  hapticStyle = null,
  style,
  contentStyle,
  textStyle,
}: WarmButtonProps) {
  return (
    <VelvetPrimaryButton
      label={title}
      onPress={onPress}
      disabled={disabled}
      loading={loading}
      flex={flex}
      fullWidth={fullWidth}
      leading={leading}
      icon={icon}
      trailing={
        trailing ??
        (showArrow ? (
          <ArrowRight size={18} color="#FFFFFF" strokeWidth={2} />
        ) : undefined)
      }
      hapticStyle={hapticStyle}
      style={style}
      contentStyle={contentStyle}
      textStyle={textStyle}
    />
  );
}
